import { StackShim as Stack } from '@fluentui/react-migration-v8-v9';
import {
  Field,
  Textarea,
  RadioGroup,
  Radio,
  FluentProvider,
  webLightTheme,
} from '@fluentui/react-components';
import React from 'react';
import { Controller, FieldValues, UseFormMethods } from 'react-hook-form';
import { yesOption, noOption } from '../../../utils/types/CommonDropdownOptions';
import { IDormancyAssessmentRequest } from '../types';
import UrlInput from '../../common/formFields/UrlInput';

interface INewDormancyAssessmentFormProps {
  form: UseFormMethods<FieldValues>;
  dormancyData?: IDormancyAssessmentRequest;
}

const DormancyAssessmentForm = ({ form, dormancyData }: INewDormancyAssessmentFormProps) => {
  const { control, errors } = form;

  return (
    <FluentProvider theme={webLightTheme}>
      <Stack tokens={{ childrenGap: 10 }}>
        <Controller
          name="hasEmployees"
          control={control}
          defaultValue={dormancyData?.hasEmployees ?? true}
          render={({ onChange, value }) => (
            <Field label="Has Employees?" required>
              <RadioGroup
                id="hasEmployees"
                value={value ? 'true' : 'false'}
                onChange={(_, data) => onChange(data.value === 'true')}
              >
                <Radio value={yesOption.key} label={yesOption.text} />
                <Radio value={noOption.key} label={noOption.text} />
              </RadioGroup>
            </Field>
          )}
        />
        <Controller
          name="hasRevenue"
          control={control}
          defaultValue={dormancyData?.hasRevenue ?? true}
          render={({ onChange, value }) => (
            <Field label="Has Revenue?" required>
              <RadioGroup
                id="hasRevenue"
                value={value ? 'true' : 'false'}
                onChange={(_, data) => onChange(data.value === 'true')}
              >
                <Radio value={yesOption.key} label={yesOption.text} />
                <Radio value={noOption.key} label={noOption.text} />
              </RadioGroup>
            </Field>
          )}
        />
        <Controller
          name="hasOperatingExpenses"
          control={control}
          defaultValue={dormancyData?.hasOperatingExpenses ?? true}
          render={({ onChange, value }) => (
            <Field label="Has Operating Expenses?" required>
              <RadioGroup
                id="hasOperatingExpenses"
                value={value ? 'true' : 'false'}
                onChange={(_, data) => onChange(data.value === 'true')}
              >
                <Radio value={yesOption.key} label={yesOption.text} />
                <Radio value={noOption.key} label={noOption.text} />
              </RadioGroup>
            </Field>
          )}
        />
        <UrlInput
          control={control}
          name="mercuryDocumentLink"
          label="Mercury Link"
          placeholder="https://microsoft.sharepoint.com/..."
          tooltip="Enter a SharePoint document link"
          defaultValue={dormancyData?.mercuryDocumentLink}
          required
          maxLength={2000}
          errorMessage={errors?.mercuryDocumentLink?.message}
        />
        <Controller
          control={control}
          name="comments"
          defaultValue={dormancyData?.comments || ''}
          rules={{
            required: 'Please enter comments.',
            validate: (value) => (value && value.trim() ? true : 'Please enter comments.'),
            maxLength: {
              value: 10000,
              message: 'Comments must be 10,000 characters or fewer.',
            },
          }}
          render={({ onChange, onBlur, value, name, ref }) => (
            <Field label="Comments" required validationMessage={errors?.comments?.message}>
              <Textarea
                id="comments"
                value={value}
                name={name}
                ref={ref}
                onBlur={onBlur}
                onChange={(ev, textareaData) => onChange(textareaData.value)}
              />
            </Field>
          )}
        />
      </Stack>
    </FluentProvider>
  );
};

export default DormancyAssessmentForm;
